import React, { useEffect, useState } from 'react';
import axios from 'axios';
import "./NotificationBar.css";
import notificationIcon from '../../Assets/notifications.png';
import { useSelector } from "react-redux";
import formatDate from './dateFormat.js';

const NotificationBar = () => {
  const [notifications, setNotifications] = useState([]);

  const { user, isAuth } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get('/api/v1/notify/notifications'); 
        console.log('Notifications fetched:', response.data); // Log the fetched data
        
        // Ensure that response.data is an array before setting state
        if (Array.isArray(response.data.notifications)) {
          let arr = response.data.notifications.map((notif) => `${notif.message}${formatDate(new Date(notif.date))}`);
          console.log(arr);
          setNotifications(arr);
        } else {
          console.error('Expected an array but got:', response.data);
          setNotifications([]); // Set to an empty array if not an array
        }
      } catch (error) {
        console.error('Error fetching notifications:', error);
        setNotifications([]); // Set to an empty array in case of an error
      }
    };

    if (isAuth){
      fetchNotifications();
    }
  }, [isAuth]);

  useEffect(() => {
    if (isAuth && user && user.preferences) {
      const textSize = user.preferences.textSize;

      switch (textSize) {
        case 0: // Small
            document.documentElement.style.setProperty('--font-size-header', '1.5vw');
            document.documentElement.style.setProperty('--font-size-label', '14px');
            document.documentElement.style.setProperty('--font-size-input', '14px');
            document.documentElement.style.setProperty('--font-size-button', '0.8vw');
            break;
        case 1: // Medium (default)
            document.documentElement.style.setProperty('--font-size-header', '2vw');
            document.documentElement.style.setProperty('--font-size-label', '16px');
            document.documentElement.style.setProperty('--font-size-input', '16px');
            document.documentElement.style.setProperty('--font-size-button', '1vw');
            break;
        case 2: // Large
            document.documentElement.style.setProperty('--font-size-header', '3vw');
            document.documentElement.style.setProperty('--font-size-label', '24px');
            document.documentElement.style.setProperty('--font-size-input', '24px');
            document.documentElement.style.setProperty('--font-size-button', '2vw');
            break;
        default:
          break;
      }
    } else if (!isAuth) {
      document.documentElement.style.setProperty('--font-size-header', '2vw');
      document.documentElement.style.setProperty('--font-size-label', '16px');
      document.documentElement.style.setProperty('--font-size-input', '16px');
      document.documentElement.style.setProperty('--font-size-button', '1vw');
    }
  }, [user, isAuth]);
  
  return (
    <div className="notificationBar">
      <div className="notificationIcon">
        <img src={notificationIcon} alt="Notifications" />
      </div>
      <div className="notificationDetails">
        <h2 className="notificationHeading">Notifications</h2>
        <ul className="notificationList">
          {notifications.length > 0 ? (
            notifications.map((notification, index) => (
              <li key={index} className="notificationItem">
                <span className="notificationText">{notification}</span>
              </li>
            ))
          ) : (
            <li className="notificationItem">No notifications available</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default NotificationBar;
